// Formata data para exibição: "15/01/2025"
export function fmtDate(d) {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

// Formata data para input type="date": "2025-01-15"
export function toInputDate(d) {
  if (!d) return ''
  return new Date(d).toISOString().split('T')[0]
}

// Formata moeda: 1234.5 → "1 234,50 €"
export function fmtEuro(v) {
  return Number(v || 0).toLocaleString('pt-PT', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  }) + ' €'
}

// Período "2025-07" → "Julho 2025"
export function fmtPeriodo(p) {
  if (!p) return '—'
  const [ano, mes] = p.split('-')
  const d = new Date(parseInt(ano), parseInt(mes) - 1, 1)
  return d.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })
}

// Hoje em formato YYYY-MM-DD
export function hoje() {
  return new Date().toISOString().split('T')[0]
}

// Período atual YYYY-MM
export function periodoAtual() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}
